import CryptoJS from "crypto-js";
import moment from "moment";
import { Environment } from "./Environment";
import { localStorageHelper } from "./global.utils";
import { refreshTokenAndStore } from "../components/common/wallet-authentication/redux/walletAuthenticationActions";

export const DEFAULT_TOKEN_LOGO =
  "https://gateway-revamp.s3.us-east-2.amazonaws.com/multiswap/Token-import.png";

export const CRUCIBLE_ALPHA_V4 = "v4";
export const CRUCIBLE_BETA = "beta";
export const Site_Name = "gateway.ferrumnetwork.io";
export const defaultEndPointDetails = Environment.defaultEndPoint();

export const CUDOS_GAS_PRICE = "5000000000000acudos";
export const IS_MULTISWAP = true;

export const DEFAULT_ESTIMATED_SWAP_TIME = "Est. time ~80 sec.";
export const COMING_SOON = "Coming Soon";
export const FIXED_ALLOCATIONS =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";
export const POLYGON_ADDITIONAL_GAS = 60000;
export const tokenFRMBSCMainnet = "0xa719b8ab7ea7af0ddb4358719a34631bb79d15dc";
export const tokenFRMxBSCMainnet = "0x8523518001ad5d24b2a04e8729743c0643a316c0";
export const tokenArbTestFrmMainnet =
  "0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA";
export const tokenUSDCBSCMainnet = "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d";
// export const stakingContractAddressListFerrum = [
//   "0x35e15ff9ebb37d8c7a413fd85bad515396dc8008",
// ];
// export const stakingContractAddressListFOMO = [
//   "0x90Bdee77ed081777C12b216f968db706f071b589",
//   "0x3e6b25a764d43ac75dd1d108ffa10eea9f42acbf",
//   "0x6c034b217287b64cb6c6970c1e556045843ee479",
// ];
export const BSC_api_key = "QFQI7J6GMJXYJW6T5GYNGNNFCWI41S21JI";
export const ARBITRUM_api_key = "NE2RB18E7CCB3T6VMFJSPAT7I82HCRTS5M";
// export const apiKey = "ckey_173b82c807954a8697b251305c5:"; // to be removed
export const TOKEN_TAG = "tokenV2";
export const TOKEN_TAG_V3 = "tokenV3";
export const ME_TAG = "meV2";
export const ORG_ROLE_TAG = "organizationAdmin";
export const COMMUNITY_ROLE_TAG = "communityMember";
export const REFRESH_TOKEN_TIMER = 600000;
export const TOKEN_VALID_TIME_MINUTES = 20;
// export const PHRASE_TOKEN =
//   "bf3fa63f66e88f4453c018f568445a03889f494343973cc33c90401d9d525447";
// export const PHRASE_PROJECT = "dbc35f418d27873591479252f9883427";
export const PUBLIC_TAG = "/pub";
export const FRM_FRMx_leaderboard_Details = {
  id: "61b6d48337f5125acbbfddeb",
  name: "FRM & FRMx BSC Leaderboard",
};
export const cFRM_Volume_Competition_Details = {
  id: "627be21bece9d7534513a7f3",
  name: "cFRM Volume Competition",
};
export const cFRMx_Volume_Competition_Details = {
  id: "627be3a2ece9d7534513a877",
  name: "cFRMx Volume Competition",
};
export const cFRM_Trading_Competition_Details = {
  id: "62826f92248e400f93b7316e",
  name: "cFRM Trading Competition",
};
export const cFRMx_Trading_Competition_Details = {
  id: "628270b8248e400f93b731cd",
  name: "cFRMx Trading Competition",
};

export const cFRMxTokenContractAddress =
  "0x1fC45F358D5292bEE1e055BA7CebE4d4100972AE";
export const arbitrumTestTokenContractAddress =
  "0xe685d3CC0be48BD59082eDe30C3b64CbFc0326e2";
export const cFRMTokenContractAddress =
  "0xaf329a957653675613D0D98f49fc93326AeB36Fc";
export const APELPCFRMBNBTokenContractAddress =
  "0x9aa0AB73409311984ED84f3Edef962201Bd11712";
export const APELPCFRMxBNBTokenContractAddress =
  "0xb76b11410A506495418D20c58F9452c17CF285c1";

export const Start_Competition_Buy_Button_Link =
  "https://pancakeswap.finance/swap?inputCurrency=0x8523518001ad5d24b2a04e8729743c0643a316c0&outputCurrency=0x1fC45F358D5292bEE1e055BA7CebE4d4100972AE&exactField=output&exactAmount=1";

// export const Ferrum_Tokens = [
//   {
//     chainId: "56",
//     token: "FRM",
//     currency: tokenFRMBSCMainnet,
//   },
//   {
//     chainId: "56",
//     token: "FRMx",
//     currency: tokenFRMxBSCMainnet,
//   },
//   {
//     chainId: "56",
//     token: "cFRM-BNB",
//     currency: APELPCFRMBNBTokenContractAddress,
//   },
//   {
//     chainId: "56",
//     token: "cFRMx-BNB",
//     currency: APELPCFRMxBNBTokenContractAddress,
//   },
//   {
//     chainId: "56",
//     token: "cFRM",
//     currency: cFRMTokenContractAddress,
//   },
//   {
//     chainId: "56",
//     token: "cFRMx",
//     currency: cFRMxTokenContractAddress,
//   },
//   {
//     chainId: "42161",
//     token: "cTestFrm",
//     currency: arbitrumTestTokenContractAddress,
//   },
//   {
//     chainId: "42161",
//     token: "testFrm",
//     currency: tokenArbTestFrmMainnet,
//   },
// ];

export function isGateWaySite() {
  if (
    window.origin.includes(CRUCIBLE_ALPHA_V4) ||
    window.origin.includes(CRUCIBLE_BETA)
  ) {
    return false;
  }
  return false;
}

export const isIncludedInRestrictedSiteList = (siteName) => {
  let restrictedSiteList = ["gateway-alcazar-world-dev.netlify.app"];
  if (restrictedSiteList.includes(siteName)) {
    return true;
  }
  return false;
};

export const encryptedKey = (data = "") => {
  let jwtSecret = process.env.REACT_APP_JWT_SECRET || "";
  let key = process.env.REACT_APP_API_KEY_FOR_APP_USER || "";
  if (data) {
    key = data;
  }
  let encryptedKey = CryptoJS.AES.encrypt(key, jwtSecret).toString();

  return encryptedKey;
};
export function storeTokenV3(token) {
  let tokenV3 = {};
  tokenV3.token = token;
  tokenV3.time = moment();
  localStorageHelper.storeObject(TOKEN_TAG_V3, tokenV3);
}
export function storeTokenV2(token) {
  localStorageHelper.storeToken(TOKEN_TAG, token);
}
export async function getValidTokenV3() {
  let tokenV3 = localStorageHelper.load(TOKEN_TAG_V3);
  let currentTime = moment();
  var duration = moment.duration(currentTime.diff(tokenV3.time));
  let minutes = duration.asMinutes();

  if (minutes > TOKEN_VALID_TIME_MINUTES) {
    await refreshTokenAndStore(tokenV3.token);
    return localStorageHelper.getToken(TOKEN_TAG);
  }

  return localStorageHelper.getToken(TOKEN_TAG);
}

export function getTokenForFiber() {
  let timelapse = 5;
  let currentTime = new Date();
  let startDateTime = moment(currentTime)
    .subtract("minutes", timelapse)
    .utc()
    .format();
  let endDateTime = moment(currentTime)
    .add("minutes", timelapse)
    .utc()
    .format(); //REACT_APP_API_KEY_FOR_GATEWAY
  const randomBytes = new Uint8Array(512); // Adjust length as needed
  let randomKey = window.crypto.getRandomValues(randomBytes);
  randomKey = randomKey.toString("hex");
  let apiKey = process.env.REACT_APP_API_KEY_FOR_GATEWAY || "";
  let tokenBody = {};
  tokenBody.startDateTime = startDateTime;
  tokenBody.endDateTime = endDateTime;
  tokenBody.randomKey = randomKey;
  tokenBody.apiKey = apiKey;
  let strTokenBody = JSON.stringify(tokenBody);
  let encryptedSessionToken = encryptedKey(strTokenBody);
  return encryptedSessionToken;
}
export const chainIdMap = {
  // BSC: 36,
  BSC: 56,
  ETHEREUM_ARBITRUM: 42161,
};

export const networksMap = {
  // 36: "BSC",
  56: "BSC",
  42161: "ARBITRUM",
};
